/*
  Cart multi-location conflict — interaction only.

  All of the logic (which countries are in the cart, whether they conflict, and which line items
  each button removes) is worked out server-side in snippets/cart-location-state.liquid and
  cart-location-conflict.liquid. The banner lives inside `.drawer__inner`, which the theme
  re-renders from the Section Rendering API on every cart change, so it stays correct without any
  MutationObserver.

  This file does two things:
  1. Handles the "Keep products from X" buttons.
  2. Blocks checkout while a conflict is on screen — interim, until the cart validation Function
     is deployed. Delete that half once it is; a Function enforces this server-side and can't be
     bypassed by express checkout the way this can.

  Listeners are delegated from `document`, so they survive the drawer's innerHTML being replaced.
*/

(function () {
  'use strict';


  var DRAWER_CONFLICT = '#cart-location-conflict-drawer';
  var CART_CONFLICT = '#cart-location-conflict-cart';

  var CHECKOUT_SELECTOR = '#CartDrawer-Checkout, #cHeckOout, #checkout';
  var CART_FORM_SELECTOR = '#CartDrawer-Form, #cart';

  /** Is there a conflict on the surface this element belongs to? */
  function hasConflict(element) {
    var selector = element.closest('cart-drawer') ? DRAWER_CONFLICT : CART_CONFLICT;
    return document.querySelector(selector) !== null;
  }


  function renderHost(button) {
    if (button.closest('cart-drawer')) {
      return document.querySelector('cart-drawer-items');
    }
    return document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  }

  function applySections(host, parsedState) {
    if (!parsedState.sections) return;

    host.getSectionsToRender().forEach(function (section) {
      var container = document.getElementById(section.id);
      if (!container) return;

      var html = parsedState.sections[section.section];
      if (!html) return;

      var target = container.querySelector(section.selector) || container;
      target.innerHTML = host.getSectionInnerHTML(html, section.selector);
    });
  }

  function keepLocation(button) {
    var inDrawer = button.closest('cart-drawer') !== null;
    var host = renderHost(button);
    if (!host) return;

    var keys = (button.dataset.removeKeys || '').split(',').filter(Boolean);
    if (!keys.length) return;

    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    button.disabled = true;

    var body = {updates: updates};

    // Sections are only needed for the in-place drawer update; the cart page reloads.
    if (inDrawer) {
      body.sections = host.getSectionsToRender().map(function (section) {
        return section.section;
      });
      body.sections_url = window.location.pathname;
    }

    // One request for every line, rather than one per line as the old injected script did.
    fetch(
      window.routes.cart_update_url,
      Object.assign({}, fetchConfig(), {body: JSON.stringify(body)})
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (parsedState) {
        if (!inDrawer) {
          /*
            Reload on the cart page. Nothing is open that a reload would close, and
            main-cart-items.liquid has two `.js-contents` divs plus a lot of stray markup, so the
            region rebuilt from the response doesn't reliably match the one being replaced — which
            left the banner in place and the checkout button greyed out. Liquid re-rendering the
            whole page is simply more trustworthy here.
          */
          window.location.reload();
          return;
        }

        // In the drawer, swap in place so it stays open.
        applySections(host, parsedState);
        dropStaleBanners();
      })
      .catch(function (error) {
        console.error('[cart-location] could not remove items', error);
        button.disabled = false;
      });
  }

  // Capture phase, so the guard runs before the theme's own checkout handlers.
  document.addEventListener(
    'click',
    function (event) {
      if (!(event.target instanceof Element)) return;

      var button = event.target.closest('[data-keep-location]');
      if (button) {
        event.preventDefault();
        event.stopPropagation();
        keepLocation(button);
        return;
      }

      var checkout = event.target.closest(CHECKOUT_SELECTOR);
      if (checkout && hasConflict(checkout)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  // Catches keyboard submits, which never fire a click on the checkout button.
  document.addEventListener(
    'submit',
    function (event) {
      if (!(event.target instanceof Element)) return;

      var form = event.target.closest(CART_FORM_SELECTOR);
      if (form && hasConflict(form)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );
})();
